<template>
  <div id="app">
    <ledmulti />
  </div>
</template>

<script>
import ledmulti from "./components/ledmulti.vue";

export default {
  name: "App",
  components: {
    ledmulti
  },
  created() {

  },
  data() {
    return {
    }
  }
};
</script>

<style>
/* @import url("https://fonts.googleapis.com/css2?family=Pangolin&display=swap"); */

/* removes blue box on click */
input,
textarea,
button,
span,
div,
select,
a {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
button:focus {
  outline: 0;
}

body {
  margin: 0px;
  background: #000;
  background-attachment: fixed;
}

#cookieBanner,
#app {
  background: transparent;
  font-family: sans-serif;
  /* font-family: "Pangolin", "Comic Sans MS", cursive, sans-serif; */

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
  user-select: none;
  /* min-height: 900px; */
  position: static;
  overflow: hidden;

  max-height: 100vh;
}
@media (max-width: 500px) {
  #app {
    /* min-height: 900px; */
    margin-top: 0px;
  }
}
@media (max-width: 400px) {
  #app {
    /* min-height: 950px; */
    margin-top: 0px;
  }
}

.totalScreenTime .span {
  font-size: 32px;
  line-height: 20px;
}

#cookieBanner-wrapper {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

#cookieBanner {
  font-weight: bold;
  font-size: 20px;
  overflow: hidden;
  padding: 20px;
  max-width: 500px;
}

@media (max-width: 600px) {
  #cookieBanner {
    font-size: 16px;
    line-height: 16px;
  }
}
@media (max-width: 360px) {
  #cookieBanner {
    font-size: 14px;
    line-height: 14px;
  }
}

#cookieBannerActions {
  margin-top: 30px;
}

a.cookie-button {
  display: inline-block;
  position: relative;
  padding: 8px 8px 8px 12px;
  background: transparent;
  color: #fff;
  border-radius: 50px;
  border: 2px solid #fff;
  margin: 0px 8px 10px;
  font-size: 24px;
  font-weight: normal;
  cursor: pointer;
  user-select: none;
  overflow: hidden;
  transform: scale(1);
  transition: all 0.2s cubic-bezier(0.49, 0.46, 0.6, 1.61);
  line-height: 24px;
  text-decoration-line: none;
}

@media (max-width: 600px) {
  .cookie-button {
    font-size: 16px;
    line-height: 16px;
  }
}
@media (max-width: 360px) {
  .cookie-button {
    font-size: 14px;
    line-height: 14px;
  }
}
</style>
